import { useContext } from "react";
import { InfiniteListContext } from "context/InfiniteList/Context";
import { MIN_RATING_ALL, POSTED_PERIOD_ALL } from "components/ListPage/filters/inlineFilterConfig";
import useQueryString from "helpers/useQueryString";
import { useAdCategories } from "hooks/reference/adCategory";
import { useCityAutocompleteFilter } from "./providerFilters/useCityAutocompleteFilter";
import { useProviderCategoryOptions } from "./providerFilters/useProviderCategoryOptions";
import { useProviderFilterActions } from "./providerFilters/useProviderFilterActions";
import { useProviderFilterOptions } from "./providerFilters/useProviderFilterOptions";
import { useProviderFilterValues } from "./providerFilters/useProviderFilterValues";

export const useInlineProviderFilters = () => {
    const { pager, activeFilters, changeFetcherParams } = useContext(InfiniteListContext);
    const { values: queryValues, setAll } = useQueryString();
    const adCategories = useAdCategories();
    const values = useProviderFilterValues(activeFilters, queryValues);
    const categoryOptions = useProviderCategoryOptions(
        adCategories.data ?? [],
        values.selectedCategories,
        values.selectedSubcategories
    );
    const city = useCityAutocompleteFilter(values.selectedCity);
    const filterOptions = useProviderFilterOptions();
    const hasSelectedCityCoordinates = values.selectedCoordinatesLat !== "" && values.selectedCoordinatesLon !== "";
    const actions = useProviderFilterActions({
        activeFilters,
        queryValues,
        currentKeyword: values.currentKeyword,
        pager,
        categories: categoryOptions.categories,
        selectedSubcategories: values.selectedSubcategories,
        setAll,
        changeFetcherParams,
        setCityInput: city.setCityInput,
        setCityOptions: city.setCityOptions,
    });

    return {
        labels: filterOptions.labels,
        options: {
            categories: categoryOptions.categoryOptions,
            subcategories: categoryOptions.subcategoryOptions,
            cities: city.cityOptions,
            minRatingClear: filterOptions.minRatingClearOption,
            minRatings: filterOptions.minRatingOptions,
            postedPeriodClear: filterOptions.postedPeriodClearOption,
            postedPeriods: filterOptions.postedPeriodOptions,
        },
        selected: {
            categories: values.selectedCategories,
            subcategories: categoryOptions.displayedSubcategories,
            postedPeriod: values.selectedPostedPeriod || POSTED_PERIOD_ALL,
            radius: values.selectedRadius,
            city: city.cityInput,
            minRating: values.selectedMinRating || MIN_RATING_ALL,
        },
        state: {
            canUseRadius: hasSelectedCityCoordinates,
            hasInlineProviderFilters: values.hasInlineProviderFilters,
        },
        handlers: actions,
    };
};
